import { Icons } from '@eppendorf/vnls-css/dist';
import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { DeviceNameCell } from '$components/device/name-cell';
import {
  AssociatedDevicesList,
  AssociatedDevicesCard,
} from '$features/devices/associated-devices/associated-devices-list/associated-devices-list';
import styles from '$features/devices/associated-devices/associated-devices-list/associated-devices-list.module.scss';
import { useGetDevice } from '$features/devices/devices.api';
import { AssociatedDevicesModel } from '$features/devices/devices.types';

export function AssociatedBox() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const [columnsData, setColumnsData] = useState<AssociatedDevicesModel[]>([]);

  const { data, isLoading: isDeviceLoading } = useGetDevice({
    manufacturer: searchParams.get('manufacturer') ?? '',
    serialNumber: searchParams.get('serialNumber') ?? '',
  });

  const {
    data: connectedBox,
    isSuccess,
    isError,
  } = useGetDevice({
    manufacturer: searchParams.get('manufacturer') ?? '',
    serialNumber: data?.connectedBox ?? '',
    enabled: !isDeviceLoading && data?.connectedBox !== null,
  });

  const allQueriesCompleted =
    !isDeviceLoading && (data?.connectedBox === null || isSuccess || isError);

  /* eslint-disable security/detect-object-injection -- Improve in future */
  useEffect(() => {
    if (allQueriesCompleted && connectedBox) {
      const device: AssociatedDevicesModel = {
        ...connectedBox,
        serialNumber: connectedBox?.serialNumber ?? data?.connectedBox ?? '',
        manufacturer: connectedBox?.manufacturer ?? 'Eppendorf',
        name: connectedBox?.name ?? '',
        connectionType: 'wired',
      };

      setColumnsData([device]);
    }
  }, [allQueriesCompleted]);
  /* eslint-enable security/detect-object-injection */

  return (
    <AssociatedDevicesList
      loading={isDeviceLoading || !allQueriesCompleted}
      showEmptyState={!isDeviceLoading && allQueriesCompleted && columnsData.length === 0}
      icon="not-wired"
      emptyTitle={t('deviceDetail.associatedBoxTable.emptyTitle')}
      emptyMessage={t('deviceDetail.associatedBoxTable.emptyMessage')}
    >
      {columnsData.map((device) => (
        <AssociatedDevicesCard
          key={device.serialNumber}
          className={styles.associatedDeviceCardWithSingleRow}
        >
          <AssociatedDevicesCard.Status>
            <Icon
              size={IconSizeClasses.Responsive}
              name={device.connectionType as Icons}
              className={styles.associatedDeviceCardIcon}
            />
          </AssociatedDevicesCard.Status>
          <AssociatedDevicesCard.Content>
            <DeviceNameCell device={device} />
          </AssociatedDevicesCard.Content>
        </AssociatedDevicesCard>
      ))}
    </AssociatedDevicesList>
  );
}
